export const WHY_SELL_AT_CATAWIKI_ID = 'why-sell-at-catawiki';

export const SELLER_FEES_TIERS = [
  {
    from: 1,
    to: 24,
    fee: 0,
    percent: 12.5,
  },
  {
    from: 25,
    to: 74,
    fee: 0.75,
    percent: 12.5,
  },
  {
    from: 75,
    to: 149,
    fee: 1,
    percent: 12.5,
  },
  {
    from: 150,
    to: 299,
    fee: 2,
    percent: 12.5,
  },
  {
    from: 300,
    to: 499,
    fee: 3,
    percent: 12.5,
  },
  {
    from: 500,
    to: 999,
    fee: 5,
    percent: 12.5,
  },
  {
    from: 1000,
    to: null,
    fee: 10,
    percent: 12.5,
  },
];
